import React, {lazy} from 'react';

const MediaNewsListViewPage = lazy(() =>
    import(/* webpackChunkName: "article.mediaNewsView" */ '@/page/article/MediaNewsListViewPage')
);

const MediaNewsViewPage = lazy(() =>
    import(/* webpackChunkName: "article.mediaNewsView" */ '@/page/article/MediaNewsViewPage')
);

const MessageNewsViewPage = lazy(() =>
    import(/* webpackChunkName: "article.newsView" */ '@/page/article/MessageNewsViewPage')
);
const ExtraNewsArticlePage = lazy(() =>
    import(
        /* webpackChunkName: "article.extranewsView" */ '@/page/extra/news/article/ExtraNewsArticlePage'
    )
);

const articleRoutes = [
    {
        path: '/article/media/:mediaId',
        element: <MediaNewsListViewPage />,
    },
    {
        path: '/article/media-news/:mediaId/:newsId',
        element: <MediaNewsViewPage />,
    },
    {
        path: '/article/news/:msgId/:newsId',
        element: <MessageNewsViewPage />,
    },
    {
        path: '/extranews/:newsItemId',
        element: <ExtraNewsArticlePage />,
    },
];

export default articleRoutes;
